import React, { ReactNode } from 'react';

type HeaderProps = {
  className?: string;
  children: ReactNode;
  truncate?: number;
  italic?: boolean;
  as: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  size?: keyof typeof sizeVariants;
};

export const sizeVariants = {
  '2xs': 'md:text-14 text-12', // Type not defined in design system
  xs: 'md:text-16 text-14',
  sm: 'md:text-20 text-18',
  base: 'text-20',
  lg: 'md:text-24 text-16',
  xl: 'md:text-32 text-28',
  '2xl': 'text-28 sm:text-36 md:text-40 lg:text-48'
};

export const Header = ({
  as,
  size = 'base',
  children,
  italic = false,
  truncate,
  className = '',
}: HeaderProps) => {
  const variantStyle = sizeVariants[size];
  const italicStyle = italic ? 'italic' : '';
  const baseStyle = 'm-0 break-words';
  const truncateStyles = {
    display: '-webkit-box',
    WebkitLineClamp: truncate,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
  };

  return React.createElement(
    as,
    {
      style: truncate && truncateStyles,
      className: `lining-nums ${baseStyle} ${variantStyle} ${italicStyle} ${className}`,
    },
    children
  );
};
